"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pie = require("cccisd-nivo/pie");
var _util = require("./util.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var GraphQLPieChart = function GraphQLPieChart(props) {
  var formatData = function formatData(raw) {
    var labelPath = props.labelPath,
      valuePath = props.valuePath,
      maxLabelLength = props.maxLabelLength,
      labelTailLength = props.labelTailLength;
    var processed = raw.map(function (row) {
      var newRow = {};
      var rowLabel = (0, _util.shorten)((0, _util.dotIndex)(labelPath, row), maxLabelLength, labelTailLength);
      var rowValue = (0, _util.dotIndex)(valuePath, row);
      newRow.id = rowLabel;
      newRow.label = rowLabel;
      newRow.value = rowValue;
      return newRow;
    });
    return processed;
  };
  var processData = function processData() {
    var data = props.data,
      rollupCount = props.rollupCount,
      rollupAtEnd = props.rollupAtEnd,
      rollupLabel = props.rollupLabel,
      valuePath = props.valuePath,
      reverseData = props.reverseData;
    if (data.length <= rollupCount) {
      if (reverseData) {
        return formatData(data).reverse();
      }
      return formatData(data);
    }
    var sorted = data.sort((0, _util.sortByValue)(valuePath));
    var newData = formatData(sorted.slice(0, rollupCount - 1));
    var otherData = sorted.slice(rollupCount - 1);
    var accumulated = otherData.reduce((0, _util.totalReducer)(valuePath), 0);
    var rollupData = {};
    rollupData.id = rollupLabel;
    rollupData.label = rollupLabel;
    rollupData.value = accumulated;
    newData.push(rollupData);
    if (!rollupAtEnd) {
      newData.sort((0, _util.sortByValue)(valuePath)).reverse();
    }
    if (reverseData) {
      return newData.reverse();
    }
    return newData;
  };
  var renderTotal = function renderTotal(chartData) {
    var totalLabel = props.totalLabel,
      showTotal = props.showTotal;
    var chartTotal = chartData.reduce((0, _util.totalReducer)('value'), 0);
    if (!showTotal) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("h5", {
      className: _style["default"].total
    }, totalLabel, ":\xA0", chartTotal);
  };
  var renderPie = function renderPie(chartData) {
    var width = props.width,
      height = props.height,
      nivo = props.nivo;
    var wrapperProps = {
      width: width,
      height: height
    };
    var defaultProps = {
      margin: {
        top: 0,
        right: 120,
        bottom: 30,
        left: 180
      },
      colors: {
        scheme: 'category10'
      },
      borderColor: {
        from: 'color',
        modifiers: [['darker', 1.6]]
      },
      sliceLabel: 'value',
      slicesLabelsTextColor: '#FFFFFF',
      radialLabelsSkipAngle: 5,
      legends: [],
      tooltip: function tooltip(_ref) {
        var id = _ref.id,
          value = _ref.value,
          color = _ref.color,
          indexValue = _ref.indexValue;
        return /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            color: color
          }
        }, id, ":"), " ", value);
      },
      animate: true,
      motionStiffness: 90,
      motionDamping: 15
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: wrapperProps
    }, renderTotal(chartData), /*#__PURE__*/_react["default"].createElement(_pie.ResponsivePie, _extends({}, defaultProps, nivo, {
      data: chartData
    })));
  };
  var chartData = processData();
  if (chartData === null) {
    return null;
  }
  return renderPie(chartData);
};
GraphQLPieChart.propTypes = {
  data: _propTypes["default"].array.isRequired,
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  labelPath: _propTypes["default"].string,
  valuePath: _propTypes["default"].string,
  maxLabelLength: _propTypes["default"].number,
  maxTailLength: _propTypes["default"].number,
  rollupCount: _propTypes["default"].number,
  rollupAtEnd: _propTypes["default"].bool,
  rollupLabel: _propTypes["default"].string,
  showTotal: _propTypes["default"].bool,
  totalLabel: _propTypes["default"].string,
  showFrequencyTable: _propTypes["default"].bool,
  frequencyTable: _propTypes["default"].object,
  nivo: _propTypes["default"].object
};
GraphQLPieChart.defaultProps = {
  width: '100%',
  height: '600px',
  labelPath: 'value',
  valuePath: 'valueCount',
  rollupCount: 10,
  rollupAtEnd: true,
  rollupLabel: 'All others',
  showTotal: false,
  totalLabel: 'Total',
  showFrequencyTable: false,
  frequencyTable: {},
  nivo: {}
};
var _default = exports["default"] = GraphQLPieChart;